import Vue from "vue";
import Vuex from "vuex";
import persistedState from "vuex-persistedstate";

import layout from "@/store/modules/layout";
import errorHandler from "@/store/modules/errorHandler";
import user from "@/store/modules/user";
import partners from "@/store/modules/partners";
import boxes from "@/store/modules/boxes";
import movements from "@/store/modules/movements";
import moving from "@/store/modules/moving";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    layout,
    errorHandler,
    user,
    partners,
    boxes,
    movements,
    moving
  },
  plugins: [
    persistedState({
      key: "store",
      paths: [
        "user.activeUser",
        "moving.qrCode",
        "moving.partner",
        "moving.withKeyBoard",
        "partners.partners"
      ]
    })
  ]
});

export default store;
